const MODULE_NAME = 'phoneNumber';
const MOBILE_PHONE_PATTERN = /^(20|30|31|50|70)(\d{3})(\d{4})$/;

export default angular.module(MODULE_NAME, [])
	.directive('phoneNumber', function () {
		'ngInject';
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				ngModel.$parsers.push(function (inputValue) {
					let formattedValue = inputValue.trim().replace(MOBILE_PHONE_PATTERN, '$1 $2 $3');
					if (formattedValue !== inputValue) {
						ngModel.$setViewValue(formattedValue);
						ngModel.$render();
					}
					return inputValue;
				});
			}
		};
	}).name;



// WEBPACK FOOTER //
// ./source/common/phone-number/phone-number.js